import { Box, styled } from '@mui/material';

export const ValidityFields = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: theme.spacing(2)
}));
